import { Component, Input } from '@angular/core';
import { DatasetColumn } from '../select-datasource-modal.model';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-dataset-column-table',
    templateUrl: './dataset-column-table.component.html',
    styleUrl: './dataset-column-table.component.scss',
    imports: [FormsModule]
})
export class DatasetColumnTableComponent {
  @Input() columns: DatasetColumn[] = [];
  @Input() loading = false;

  trackByColumnKey(_: number, column: DatasetColumn): string {
    return column.key;
  }
}
